import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LandingLayout, DashboardLayout } from 'src/layouts/dashboard';
import { DashboardContextProvider } from 'src/context/dashboard/dashboard-context';

import { LoadingScreen } from 'src/components/loading-screen';

import { BranchEditView } from 'src/sections/branch/view/branch-edit-view';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// Overview
const IndexPage = lazy(() => import('src/pages/dashboard'));
const DashboardLandingPage = lazy(() => import('src/pages/dashboard/landing'));
const CreateRestaurantView = lazy(() => import('src/pages/dashboard/landing/create-restaurant'));
// Branches
const BranchCreateView = lazy(() => import('src/pages/dashboard/branches/new'));
const BranchListView = lazy(() => import('src/pages/dashboard/branches/list'));
// Categories
const CategoryListView = lazy(() => import('src/pages/dashboard/categories/list'));
const CategoryCreateView = lazy(() => import('src/pages/dashboard/categories/new'));
const CategoryEditView = lazy(() => import('src/pages/dashboard/categories/edit'));

// Product

const ProductListPage = lazy(() => import('src/pages/dashboard/product/list'));
const ProductCreatePage = lazy(() => import('src/pages/dashboard/product/new'));
const ProductEditPage = lazy(() => import('src/pages/dashboard/product/edit'));

// ----------------------------------------------------------------------

// Sorting
const SortingPage = lazy(() => import('src/pages/dashboard/sorting'));

const layoutContent = (withLayout: boolean) => (
  <AuthGuard>
    <DashboardContextProvider>
      {withLayout ? (
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ) : (
        <Outlet />
      )}
    </DashboardContextProvider>
  </AuthGuard>
);

export const dashboardRoutes = [
  // user landing without layout
  {
    path: 'dashboard',
    element: layoutContent(false),
    children: [
      {
        index: true,
        element: (
          <LandingLayout>
            <DashboardLandingPage />
          </LandingLayout>
        ),
      },
      {
        path: 'create-restaurant',
        element: (
          <LandingLayout>
            <CreateRestaurantView />
          </LandingLayout>
        ),
      },
    ],
  },
  // dashboard routes with layout
  {
    path: 'dashboard',
    element: layoutContent(true),
    children: [
      { path: 'home', element: <IndexPage /> },
      {
        path: 'branches',
        children: [
          { path: 'list', element: <BranchListView /> },
          { path: 'new', element: <BranchCreateView /> },
          { path: 'edit/:id', element: <BranchEditView /> },
        ],
      },
      {
        path: 'categories',
        children: [
          { path: 'list', element: <CategoryListView /> },
          { path: 'new', element: <CategoryCreateView /> },
          { path: 'edit/:id', element: <CategoryEditView /> },
        ],
      },

      {
        path: 'products',
        children: [
          { element: <ProductListPage />, index: true },
          { path: 'list', element: <ProductListPage /> },
          { path: 'new', element: <ProductCreatePage /> },
          { path: 'edit/:id', element: <ProductEditPage /> },
        ],
      },
      {
        path: 'sorting',
        element: <SortingPage />,
      },
    ],
  },
];
